import { api } from "@/api";

export const deleteBettingMarketMapping = async (
  marketId: number,
  id: number
): Promise<void> => {
  await api.client.delete(`/betting-markets-new/${marketId}/mappings/${id}`);
};
